import React, { ChangeEvent } from 'react'
import { DraggableProvided } from 'react-beautiful-dnd'
import { ArrayField, Control, Controller } from 'react-hook-form'
import { ControlledHiddenInput } from 'transfix-form/components'
import { Typography, makeStyles } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'
import { DeleteIcon, DragHandleIcon } from 'transfix-icons'
import { Button, TextField } from 'transfix-ui'

interface IListStepItemProps {
  item: Partial<ArrayField<Record<string, any>, 'id'>>
  provided: DraggableProvided
  index: number | any
  control: Control
  onClick: (index: number) => void
  parentName: string
  error?: string
}

const useStepItemClasses = makeStyles(() => ({
  containerListItem: {
    display: 'flex',
    gap: '15px',
  },
  dragHandleContainer: {
    padding: '10px 0',
    color: brandColors.coolGray5,
  },
  iconAction: {
    transform: `scale(1.3)`,
    cursor: 'pointer',
  },
  listItemIndex: {
    fontSize: '14px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  addStepContainer: {
    color: brandColors.skyBlue6,
    padding: '20px 75px',
    fontSize: '15px',
    margin: '0px 5px',
    fontWeight: 'normal',
  },
  removeIcon: {
    border: 'none',
    minWidth: '25px',
  },
}))

export const ListStepItem: React.FunctionComponent<IListStepItemProps> = ({
  control,
  error,
  index,
  item,
  onClick,
  parentName,
  provided,
}) => {
  const classes = useStepItemClasses()

  return (
    <li
      key={item.id}
      ref={provided.innerRef}
      {...provided.draggableProps}
      className={classes.containerListItem}>
      <div {...provided.dragHandleProps} className={classes.dragHandleContainer}>
        <DragHandleIcon className={classes.iconAction} />
      </div>
      <Typography className={classes.listItemIndex}>{index + 1}</Typography>
      <Controller
        control={control}
        name={`${parentName}[${index}].name`}
        defaultValue={item.description || item.name}
        render={({ onChange, ...props }) => {
          const changeHandler = ({
            target: { value: val = '' },
          }: ChangeEvent<HTMLInputElement>) => {
            onChange(val)
          }
          return (
            <TextField
              {...props}
              onChange={changeHandler}
              placeholder='Add step details'
              large
              error={Boolean(error)}
              validationMessage={error}
            />
          )
        }}
      />
      <ControlledHiddenInput
        control={control}
        name={`${parentName}[${index}].description`}
        defaultValue={item.description}
      />
      <ControlledHiddenInput
        control={control}
        name={`${parentName}[${index}].itemId`}
        defaultValue={item.itemId}
      />
      <div className={classes.dragHandleContainer}>
        <Button className={classes.removeIcon} onClick={() => onClick(index)}>
          <DeleteIcon className={classes.iconAction} />
        </Button>
      </div>
    </li>
  )
}
